import { withPrefix } from "gatsby";
import { retrieveOneTrust } from "./onetrust";
const DEV_PATH_PREFIX = process.env.PATH_PREFIX ?? "";

const bazaarVoiceGroups = ["C0003"];
const siteLocale = DEV_PATH_PREFIX || withPrefix("/");

export const BAZAAR_VOICE_SCRIPT_ID = "bazaar-voice-loader";
const FAKE_OT_BANNER_ID = "cookie_banner";

function createScript() {
  // Non creare lo script se è già presente
  if (document.getElementById(BAZAAR_VOICE_SCRIPT_ID)) {
    return;
  }
  const script = document.createElement("script");
  script.id = BAZAAR_VOICE_SCRIPT_ID;
  script.setAttribute(
    "src",
    `https://apps.bazaarvoice.com/deployments/haier-europe/main_site/production${siteLocale}bv.js`
  );
  script.setAttribute("async", "");
  document.head.appendChild(script);
}

function areEnabledBazaarVoiceCookies() {
  return (
    window.OnetrustActiveGroups &&
    bazaarVoiceGroups.some((item) => window.OnetrustActiveGroups.includes(item))
  );
}

let groupsListener = null;

export async function insertBazaarVoiceScript() {
  // Inserisci sempre lo script se siamo in locale
  if (process.env.NODE_ENV === "development") {
    createScript();
    return;
  }
  if (!groupsListener) {
    // Crea il listener solo una volta
    groupsListener = () => {
      if (areEnabledBazaarVoiceCookies()) {
        createScript();
      }
    };
    window.addEventListener("OneTrustGroupsUpdated", groupsListener);
  }

  // Aspetta che OneTrust sia caricato
  const oneTrust = await retrieveOneTrust();
  if (!oneTrust) {
    return;
  }
  // Listener del banner di OneTrust
  if (typeof oneTrust.OnConsentChanged === "function") {
    oneTrust.OnConsentChanged((e) => {
      if (areEnabledBazaarVoiceCookies()) {
        createScript();
      }
    });
  }
  if (
    // Controlla se il banner è chiuso o se il banner è "fake" (Svizzera)
    ((typeof oneTrust.IsAlertBoxClosed === "function" && oneTrust.IsAlertBoxClosed()) ||
      document.getElementById(FAKE_OT_BANNER_ID)) &&
    areEnabledBazaarVoiceCookies()
  ) {
    createScript();
  }
}
